import { render } from "./OWidgetImage.vue?vue&type=template&id=0b46b783&scoped=true"
import script from "./OWidgetImage.vue?vue&type=script&lang=js"
export * from "./OWidgetImage.vue?vue&type=script&lang=js"

import "./OWidgetImage.vue?vue&type=style&index=0&id=0b46b783&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b46b783"]])

export default __exports__